import React from 'react';

const BR = ({height = 4})=> <div style={{height}}/>

export default BR;